import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import logSlice from "./reducers/log.slice";
import authSlice from "./reducers/auth.slice";
import roleSlice from "./reducers/role.slice";
import documentsSlice from "./reducers/documents.slice";
import attributeSlice from "./reducers/attribute.slice";
import documentsHistories from "./reducers/documents.histories";
import sourceSlice from "./reducers/sources.slice";
import divisionsSlice from "./reducers/divisions.slice";
import organizationalUnitSlice from "./reducers/organizational.units.slice";

/**
 * Combines all the individual slices into a single root reducer.
 * 
 * @constant
 * @type {Reducer}
 * 
 * @property {Reducer} logs - Handles the state for logs.
 * @property {Reducer} user - Manages authentication state.
 * @property {Reducer} roles - Manages roles state.
 * @property {Reducer} documents - Manages documents state.
 * @property {Reducer} attributes - Manages attributes state.
 * @property {Reducer} sources - Manages sources state.
 * @property {Reducer} documentsHistories - Manages document histories state.
 * @property {Reducer} divisions - Manages divisions state.
 * @property {Reducer} organizationalunits - Manages organizational units state.
 */

const persistConfig = {
  key: "root",
  storage,
  // whitelist: ["user"],
  // blacklist: ["logs", "targets", "roles", "documents", "attributes", "Sources"],
};


const reducers = combineReducers({
  logs: logSlice,
  user: authSlice,
  roles: roleSlice,
  documents: documentsSlice,
  attributes: attributeSlice,
  sources: sourceSlice,
  documentsHistories: documentsHistories,
  divisions: divisionsSlice,
  organizationalunits: organizationalUnitSlice
});

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;